module.exports = __webpack_public_path__ + "static/inspect_mode_gif-4544bf82fde4ebef6bdef27f7dda363a.webm";